import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  data: [],
  filteredTotal: 0,
  filters: [],
  loading: false,
  total: 0,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters } = payload;

  return {
    ...state,
    data,
    filteredTotal,
    filters,
    loading: false,
    total,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
